'use strict';
var validator = require('../validator');
var populateErrorMessages = require('../validationMessage');
const smoothscroll = require('smoothscroll-polyfill');
var debounce = require('lodash/debounce');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var newsletterErrorMessages = {};
var DOMPurify = require('dompurify');

/**
 * Generate Modal HTML
 * @param {Object} modalId - modal Id for different modals
*/
function getModalHtmlElement(modalId) {
    const $modalContainer = $(`#${modalId}.modal`);
    if ($modalContainer.length !== 0) {
        $modalContainer.remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="' + modalId + '" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog modal-dialog-centered">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-body"></div>' +
        '<div></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Handle Newsletter Email Validation
 * @param {string} fromId - Id of the newletter form
 * @param {string} registrationEmailId - Id of the email field
 */
function newsletterEmailError(fromId, registrationEmailId) {
    var $newsletterForm = $(fromId);
    var $subscribeEmail = $newsletterForm.find(registrationEmailId);
    populateErrorMessages(newsletterErrorMessages, $subscribeEmail);
    validator.init($newsletterForm, {
        ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
        ...validator.ENABLED_BUTTON_SETTINGS,
        messages: newsletterErrorMessages
    });
}

/**
 * Function to show or validate error msg on submit of newsletter form
 * @param {Object} data - data coming from response on submit
*/
function showErrorMsgOnNewsletter(data, modalContainer = '') {
    var hideNewsletterTime = $('.global-footer').data('hidenewslettertime');
    if (data.error) {
        // eslint-disable-next-line no-useless-concat
        $(modalContainer + ' ' + '.newsletter-error-msg').html(`<svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg><div class="error-msg-text">${data.errorMsg}</div>`);
        return;
    }
    if (data.alreadySubscribed === 'false') {
        $('.form-column').addClass('d-none');
        $('.thanks-column').removeClass('d-none');
        setTimeout(() => {
            $('#pvh-newsletter-subs').modal('hide');
            $('#pvh-newsletter-subs-modal').length > 0 && $('#pvh-newsletter-subs-modal').modal('hide');
        }, hideNewsletterTime);
    } else if (data.alreadySubscribed === 'true') {
        $(modalContainer + ' ' + '.newsletter-error-msg').html(`<svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg>${data.errorMsg}`);
    }
}


/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
            '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    oninit: function () {
        var $orderStatusLink = $('#order-status-link');
        var $trackUrl = DOMPurify.sanitize($('#trackUrl').val());
        if ($orderStatusLink) {
            $orderStatusLink.attr('href', $trackUrl);
        }

        // hack to prevent footer form input from getting focus
        // in page which does not have other focus element
        var $newsletterForm = $('#emailOptinForm');
        var $subscribeEmail = $newsletterForm.find('#registration-form-email-footer');
        setTimeout(() => {
            $subscribeEmail.removeAttr('disabled');
        }, 300);

        // Enable smooth scroll
        smoothscroll.polyfill();

        /**
         * The year in copyright placement dynamic that always shows the current year.
        */
        var getEleYear = document.getElementById('currentYear');
        if (getEleYear) {
            document.getElementById('currentYear').innerHTML = new Date().getFullYear();
        }

        var webId = window.sessionStorage.getItem('webId');
        if (webId) {
            $('.webiddesk-footer').html('Web ID: ' + webId);
        }
    },

    backToTopBtn: function () {
        const toggleBackToTopButton = () => {
            if ($(window).scrollTop()) {
                $('#backToTop').css('display', 'flex').fadeIn();
                if($('enchat-chat-window').hasClass('visible-chat-window')) {
                    $('#backToTop').css('bottom', '104px');
                }
            } else {
                $('#backToTop').fadeOut();
            }
        };

        // toggle back to top button on scroll and on load if required
        $(window).on('scroll', debounce(() => toggleBackToTopButton()));
        toggleBackToTopButton();


        // scroll back to top on lick
        $('#backToTop').on('click', function () {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        });
    },

    newsletterModalOpenFooterBtn: function () {
        $('.subscribe-email').on('click', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var button = $(this);
            var emailId = $('input[name=hpEmailSignUp]').val();
            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    emailId: emailId
                },
                success: function (data) {
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });

        $('.newsletter-footer-btn .newsletter-sub-btn').on('click', function (e) {
            e.preventDefault();
            $.spinner().start();
            var newsLetterModalUrl = $('.newsletter-footer-btn .newsletter-sub-btn').attr('data-url');
            $.ajax({
                url: newsLetterModalUrl,
                type: 'get',
                success: function (data) {
                    getModalHtmlElement('pvh-newsletter-subs-modal');
                    $('#pvh-newsletter-subs-modal .modal-body').html(data);
                    $('#pvh-newsletter-subs-modal').modal('show');
                    $('#welcomeSource').val('WE_FOOTER');
                    $('#pvh-newsletter-subs-modal').data('emailSignUpLocation', 'footer modal');
                    newsletterEmailError('#emailOptinForm', '#registration-form-email');
                    newsletterEmailError('#emailOptinFormModal', '#registration-form-email-modal');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    // Temp fix for multiple bootstrap triggers on cart page
    cartFooterException: function () {
        $('.ds-mobile-footer .accordionHeader .btn').on('click', function (e) {
            var toggleButton = $(this);
            var targetCollapse = $(toggleButton.data('target'));
            if (targetCollapse.hasClass('show') && $('.page.current.cart').length) {
                e.preventDefault();
                e.stopImmediatePropagation();
                targetCollapse.collapse('hide');
                toggleButton.addClass('collapsed');
            }
        });
    },

    submitNewsletterForm: function () {
        $(document).on('submit', 'form#emailOptinForm', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var url = $('#emailOptinFormBtn').data('url');
            var emailSignUpLocation = $('#pvh-newsletter-subs-modal').data('emailSignUpLocation');
            if ($(this).parents('.ds-footer-join-club').length) {
                emailSignUpLocation = 'embedded email form in footer';
            }
            var email = $('input#registration-form-email-footer');
            email.val($.trim(email.val()));
            if ($('#add-to-email-list').is(':checked')) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: $('form#emailOptinForm').serialize(),
                    success: function (data) {
                        showErrorMsgOnNewsletter(data);
                        if (data.alreadySubscribed === 'false') {
                            tealiumEnable.getAnalyticsData('emailOptInTracking', emailSignUpLocation, data.email);
                        }
                    },
                    error: function (err) {
                        if ('responseJSON' in err) {
                            showErrorMsgOnNewsletter(err.responseJSON);
                        }
                    }
                });
            } else {
                $('form#emailOptinForm .check-box-error').removeClass('d-none');
            }
        });
        $(document).on('submit', 'form#emailOptinFormModal', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var url = $('#emailOptinFormBtn').data('url');
            if ($('#add-to-email-list-modal').is(':checked')) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: $('form#emailOptinFormModal').serialize(),
                    success: function (data) {
                        showErrorMsgOnNewsletter(data, '#emailOptinFormModal');
                        if (data.alreadySubscribed === 'false') {
                            var emailSignUpLocation = $('#pvh-newsletter-subs-modal').data('emailSignUpLocation');
                            tealiumEnable.getAnalyticsData('emailOptInTracking', emailSignUpLocation, data.email);
                        }
                    }
                });
            } else {
                $('form#emailOptinFormModal .check-box-error').removeClass('d-none');
            }
        });

        $(document).on('click', '#add-to-email-list', function () {
            if ($(this).is(':checked')) {
                $('form#emailOptinForm .check-box-error').addClass('d-none');
            }
        });
        $(document).on('click', '#add-to-email-list-modal', function () {
            if ($(this).is(':checked')) {
                $('form#emailOptinFormModal .check-box-error').addClass('d-none');
            }
        });
    },

    newsletterErorrMsgHide: function () {
        $(document).on('click', 'form #registration-form-email', function () {
            $('.newsletter-error-msg').empty();
        });
    },

    openChatWindow: function () {
        $(document).on('click', '.cs-live-chat', function (e) {
            e.preventDefault();
            $('enchat-chat-window').css('display','block');
            $('enchat-chat-window').addClass('visible-chat-window');
            if ($(window).scrollTop()) {
                if($('enchat-chat-window').hasClass('visible-chat-window')) {
                    $('#backToTop').css('bottom', '104px');
                }
            }
            window.embeddedservice_bootstrap.utilAPI.launchChat();
            window.embeddedservice_bootstrap.utilAPI.showChatButton();
        });
    },

    createCookieFindingMethod: function () {
        $(document).on('click', '#atsuggestions .atsuggestions-item', function () {
            cookieSet.set('finding_method', 'Recommendations');
        });
        $(document).on('click', '#quickViewModal a.quickview__modal-heading-link, #quickViewModal .viewdetails-link a', function () {
            if ($('.page.current.product').length) {
                var recommendationType = $(this).closest('#quickViewModal').data('recomtype');
                if (recommendationType.toLowerCase() === 'einstein') {
                    cookieSet.set('finding_method', 'ctl_einstein');
                } else {
                    cookieSet.set('finding_method', 'ctl_custom');
                }
            }
        });
        $(document).on('click', '.quickview-set .viewdetails-link, .quickview-set .quickview__modal__head--name', function () {
            cookieSet.delete('navToPDP');
            cookieSet.set('finding_method', 'bundle');
            var tealiumData = $('.datalayer-view-event').data('tealium-view');
            let bundle_style_id = !!tealiumData && tealiumData.length > 0 && tealiumData[0].product_bundle_style_id && tealiumData[0].product_bundle_style_id.length ? tealiumData[0].product_bundle_style_id[0] : '';
            cookieSet.set('bundle_style_id', bundle_style_id);
        });
        $(document).on('click', '#quickViewModal .quickview__modal__head--name', function () {
            if (!$('.page.current.product').length) {
                cookieSet.set('finding_method', 'quickView');
                cookieSet.delete('navToPDP');
                var tealiumData = $('.datalayer-view-event').data('tealium-view');
                if (!!tealiumData && tealiumData.length > 0) {
                    cookieSet.set('productMerchCategory', [tealiumData[0].page_name.replace(/\s/g, '%20')]);
                }
            }
        });

        $(document).on('click', '.popular-category-container .popular-category-names', function () {
            cookieSet.set('finding_method', 'popular-cat-preview');
        });
    },

    deleteCookieFindingMethod: function () {
        $(document).on('click', '#headerComponent a', function () {
            // eslint-disable-next-line no-script-url
            if ($(this).attr('href') !== 'javascript:void(0)') {
                cookieSet.delete('navToPDP');
                cookieSet.delete('finding_method');
                cookieSet.delete('productMerchCategory');
            }
        });

        $('#footercontent a').on('click', function () {
            cookieSet.delete('navToPDP');
            cookieSet.delete('finding_method');
            cookieSet.delete('productMerchCategory');
        });

        const searchinput = document.querySelector('input.search-field');
        if (searchinput) {
            searchinput.addEventListener('keyup', (event) => {
                if (event.key === 'Enter') {
                    cookieSet.delete('navToPDP');
                }
            });
        }

        $(document).on('click', 'a', function () {
            cookieSet.set('trackNavigation', 'linkClicked');
        });
        cookieSet.delete('trackNavigation');
        cookieSet.delete('bundle_style_id');
    },

    newsletterPrivacyModal: function () {
        $(document).on('click', '#newletterPolicyModal .close', function () {
            $('#newletterPolicyModal').modal('hide');
        });
    },
    footerNewsletterValidationHandler: function () {
        var $footerNewsletter = $('.newsletter-footer-form');
        var $Email = $footerNewsletter.find('#registration-form-email-footer');
        populateErrorMessages(newsletterErrorMessages, $Email);
        validator.init($footerNewsletter, {
            ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
            ...validator.ENABLED_BUTTON_SETTINGS,
            messages: newsletterErrorMessages
        });
    }
};
